const RolesList = () => {

    return (
        <>

         <div className="search role-bx">
                <svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="7"></circle><path d="M21 21l-4.3-4.3"></path></svg>
                <input id="mainSearch" placeholder="Search people…" oninput="renderTab()"/>
            </div>
          
<div id="listArea" className="list role_list">
  <div className="list-rolerow">
    <div className="who">
      <div className="nm">Sales Executive</div>
      <div className="desc">Front-line sales</div>
    </div>
    <div className="stats">
      <button className="stat" >
        <span className="lbl">People</span>
        <span className="n">2</span>
      </button>
      <button className="stat" >
        <span className="lbl">Permissions</span>
        <span className="n">5</span>
      </button>
    </div>
  </div>

  <div className="list-rolerow">
    <div className="who">
      <div className="nm">Team Leader</div>
      <div className="desc">Leads a sales team</div>
    </div>
    <div className="stats">
      <button className="stat" >
        <span className="lbl">People</span>
        <span className="n">2</span>
      </button>
      <button className="stat" >
        <span className="lbl">Permissions</span>
        <span className="n">7</span>
      </button>
    </div>
  </div>

  <div className="list-rolerow">
    <div className="who">
      <div className="nm">Booking Desk</div>
      <div className="desc">Handles bookings &amp; registry</div>
    </div>
    <div className="stats">
      <button className="stat" >
        <span className="lbl">People</span>
        <span className="n">1</span>
      </button>
      <button className="stat" >
        <span className="lbl">Permissions</span>
        <span className="n">4</span>
      </button>
    </div>
  </div>

  <div className="list-rolerow">
    <div className="who">
      <div className="nm">Manager</div>
      <div className="desc">Full sales oversight</div>
    </div>
    <div className="stats">
      <button className="stat">
        <span className="lbl">People</span>
        <span className="n">1</span>
      </button>
      <button className="stat" >
        <span className="lbl">Permissions</span>
        <span className="n">10</span>
      </button>
    </div>
  </div>

  <div className="list-rolerow">
    <div className="who">
      <div className="nm">Admin</div>
      <div className="desc">System administrator</div>
    </div>
    <div className="stats">
      <button className="stat">
        <span className="lbl">People</span>
        <span className="n">1</span>
      </button>
      <button className="stat" >
        <span className="lbl">Permissions</span>
        <span className="n">12</span>
      </button>
    </div>
  </div>
</div>

        </>
    )
}

export default RolesList;